import { useEffect, useState } from "react";
import axios from "axios";
import CustomLoader from "./CustomLoader";
import api from "../utils/axios";

import { formatCurrency, formatNumber, formatAmount } from "../helpers";
const BonusAndPaneltyHistory = () => {
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = localStorage.getItem("token");

useEffect(() => {
    if (!token) {
      setError("No token found. Please log in.");
      setLoading(false);
      return;
    }
    fetchTransactionHistory(page, limit);
  }, [page]);

  const fetchTransactionHistory = async (page, limit) => {
    setLoading(true);
    try {
      const response = await api.get(
        `/userCreditTransactions?page=${page}&pageSize=${limit}`,
      );

      const { data, pagination } = response.data;

      setTransactionHistory(data || []);
      setTotalPages(pagination?.totalPages || 1);
      setPage(pagination?.currentPage || 1);
    } catch (err) {
      console.error("Failed to fetch transaction history:", err);
      setError("Failed to fetch transaction history");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) setPage(newPage);
  };

  return (
    <div className="">
      <div className="mb-10">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">
          Transaction History
        </h2>

        {loading ? (
          <CustomLoader />
        ) : error ? (
          <p className="text-red-600">{error}</p>
        ) : (
          <>
            <div className="overflow-x-auto rounded-xl border bg-white">
              <table className="min-w-full border border-gray-200 divide-y divide-gray-200">
                <thead className="bg-gray-100 text-gray-700">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-bold">#</th>
                    {/* <th className="px-4 py-3 text-left text-sm font-bold">Sender ID</th>
                    <th className="px-4 py-3 text-left text-sm font-bold">Receiver ID</th>
                    <th className="px-4 py-3 text-left text-sm font-bold">Receiver Role</th> */}
                    <th className="px-4 py-3 text-left text-sm font-bold">Amount</th>
                    <th className="px-4 py-3 text-left text-sm font-bold">Type</th>
                    <th className="px-4 py-3 text-left text-sm font-bold">Remarks</th>
                    <th className="px-4 py-3 text-left text-sm font-bold">Date</th>
                  </tr>
                </thead>
                <tbody className="text-sm text-gray-800 divide-y divide-gray-200">
                  {transactionHistory.map((item, index) => (
                    <tr key={item.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3">{(page - 1) * limit + index + 1}</td>
                      {/* <td className="px-4 py-3">{item.admin_id}</td>
                      <td className="px-4 py-3">{item.user_id}</td>
                      <td className="px-4 py-3">{"User"}</td> */}
                      <td className="px-4 py-3">{formatCurrency(item.amount)}</td>
                      <td className={item.type == "credited" ? "px-4 py-3 text-green-600" : "px-4 py-3 text-red-600"}>{item.type == "credited" ? "Credit" : "Debit"}</td>
                      <td className="px-4 py-3">{item.remarks}</td>
                      <td className="px-4 py-3">{new Date(item.created_at).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="mt-6 flex justify-center items-center space-x-4">
              <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 1}
                className={`px-4 py-2 rounded ${page === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-blue-500 text-white hover:bg-blue-600"
                  }`}
              >
                Prev
              </button>
              <span className="text-gray-700">
                Page <strong>{page}</strong> of <strong>{totalPages}</strong>
              </span>
              <button
                onClick={() => handlePageChange(page + 1)}
                disabled={page === totalPages}
                className={`px-4 py-2 rounded ${page === totalPages
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-500 text-white hover:bg-blue-600"
                  }`}
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BonusAndPaneltyHistory;
